import styled from 'styled-components';

const Page = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #f3f3f3;
`;

export default Page;